import { useEffect, useRef } from 'react';

export interface CommandBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  shortcutHint?: string;
  autoFocus?: boolean;
  onSubmit?: () => void;
}

/** A single, calm command/search input. There is only ever one of these. */
export function CommandBar({
  value,
  onChange,
  placeholder = 'Search or jump to anything…',
  shortcutHint = 'Ctrl K',
  autoFocus,
  onSubmit,
}: CommandBarProps) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (autoFocus) ref.current?.focus();
  }, [autoFocus]);

  return (
    <div className="lc-cmdbar">
      <span aria-hidden>⌕</span>
      <input
        ref={ref}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSubmit?.();
        }}
        aria-label="Search"
      />
      <kbd>{shortcutHint}</kbd>
    </div>
  );
}
